// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as PricingDashboardDataMachine from "../../../pricing-dashboard/app/PricingDashboardDataMachine.bs.js";
import * as AllocationDashboardDataMachine from "../../app/repo/AllocationDashboardDataMachine.bs.js";

function reducer(state, action) {
  if (typeof action === "number") {
    switch (action) {
      case /* ClearSnackbar */0 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: state.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: state.refresh_campaign_list,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: undefined,
                  current_view: state.current_view,
                  filtered_allocation_campaings: state.filtered_allocation_campaings,
                  modal: state.modal,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* RefreshCampaignList */1 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: state.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: true,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: state.current_view,
                  filtered_allocation_campaings: state.filtered_allocation_campaings,
                  modal: state.modal,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* ClearSelectedGeoRegion */2 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: undefined,
                  vehicles: state.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: state.refresh_campaign_list,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: /* GeoRegionView */1,
                  filtered_allocation_campaings: state.filtered_allocation_campaings,
                  modal: state.modal,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* CloseModal */3 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: state.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: state.refresh_campaign_list,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: state.current_view,
                  filtered_allocation_campaings: state.filtered_allocation_campaings,
                  modal: undefined,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* DoNothing */4 :
          return state;
      
    }
  } else {
    switch (action.TAG | 0) {
      case /* SetUserRole */0 :
          return {
                  user_role: action.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: state.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: state.refresh_campaign_list,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: state.current_view,
                  filtered_allocation_campaings: state.filtered_allocation_campaings,
                  modal: state.modal,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* SetGeoRegionList */1 :
          return {
                  user_role: state.user_role,
                  geo_regions: action.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: state.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: state.refresh_campaign_list,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: state.current_view,
                  filtered_allocation_campaings: state.filtered_allocation_campaings,
                  modal: state.modal,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* UpdateSelectedGeoRegion */2 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: action.selected_geo_region,
                  vehicles: /* Init */0,
                  selected_vehicle: undefined,
                  refresh_campaign_list: state.refresh_campaign_list,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: state.current_view,
                  filtered_allocation_campaings: /* Init */0,
                  modal: state.modal,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* SetVehicleList */3 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: action.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: state.refresh_campaign_list,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: state.current_view,
                  filtered_allocation_campaings: state.filtered_allocation_campaings,
                  modal: state.modal,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* UpdateSelectedVehicle */4 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: state.vehicles,
                  selected_vehicle: action.selected_vehicle,
                  refresh_campaign_list: true,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: state.current_view,
                  filtered_allocation_campaings: /* Init */0,
                  modal: state.modal,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* UpdateFilters */5 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: state.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: state.refresh_campaign_list,
                  applied_filters: action.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: state.current_view,
                  filtered_allocation_campaings: state.filtered_allocation_campaings,
                  modal: state.modal,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* UpdateSidebarState */6 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: state.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: state.refresh_campaign_list,
                  applied_filters: state.applied_filters,
                  opened_sidebar: action.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: state.current_view,
                  filtered_allocation_campaings: state.filtered_allocation_campaings,
                  modal: state.modal,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* OpenSnackbar */7 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: state.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: state.refresh_campaign_list,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: action.snackbar_message,
                  current_view: state.current_view,
                  filtered_allocation_campaings: state.filtered_allocation_campaings,
                  modal: state.modal,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* UpdateCurrentView */8 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: state.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: state.refresh_campaign_list,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: action.current_view,
                  filtered_allocation_campaings: state.filtered_allocation_campaings,
                  modal: state.modal,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* SetAllocationCamapigns */9 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: state.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: action.refresh_campaign_list,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: state.current_view,
                  filtered_allocation_campaings: action.filtered_allocation_campaings,
                  modal: state.modal,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* OpenModal */10 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: state.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: state.refresh_campaign_list,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: state.current_view,
                  filtered_allocation_campaings: state.filtered_allocation_campaings,
                  modal: action.modal,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* SetZones */11 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: state.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: state.refresh_campaign_list,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: state.current_view,
                  filtered_allocation_campaings: state.filtered_allocation_campaings,
                  modal: state.modal,
                  zones: action.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* SetClusters */12 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: state.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: state.refresh_campaign_list,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: state.current_view,
                  filtered_allocation_campaings: state.filtered_allocation_campaings,
                  modal: state.modal,
                  zones: state.zones,
                  clusters: action.clusters,
                  zoneClusterCampaigns: state.zoneClusterCampaigns
                };
      case /* SetZoneClusterCamapigns */13 :
          return {
                  user_role: state.user_role,
                  geo_regions: state.geo_regions,
                  selected_geo_region: state.selected_geo_region,
                  vehicles: state.vehicles,
                  selected_vehicle: state.selected_vehicle,
                  refresh_campaign_list: state.refresh_campaign_list,
                  applied_filters: state.applied_filters,
                  opened_sidebar: state.opened_sidebar,
                  snackbar_message: state.snackbar_message,
                  current_view: state.current_view,
                  filtered_allocation_campaings: state.filtered_allocation_campaings,
                  modal: state.modal,
                  zones: state.zones,
                  clusters: state.clusters,
                  zoneClusterCampaigns: action.zoneClusterCampaigns
                };
      
    }
  }
}

function storeSelectedGeoRegionIdInLocalStorage(selected_geo_region) {
  if (selected_geo_region !== undefined) {
    window.localStorage.setItem("selected_geo_region_id", JSON.stringify(selected_geo_region.id));
    return ;
  }
  
}

function storeSelectedVehicleIdInLocalStorage(selected_vehicle) {
  if (selected_vehicle !== undefined) {
    window.localStorage.setItem("selected_vehicle_id", JSON.stringify(selected_vehicle.vehicle_id));
    return ;
  }
  
}

function fetchZones(geo_region, dispatch, country) {
  var geo_Region_id = String(geo_region.id);
  return PricingDashboardDataMachine.fetchZones(geo_Region_id, (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* SetZones */11,
                            zones: {
                              TAG: /* Live */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* SetZones */11,
                            zones: {
                              TAG: /* Error */2,
                              _0: error
                            }
                          });
              }), country);
}

function fetchClusters(geo_region, dispatch, country) {
  var geo_Region_id = String(geo_region.id);
  return PricingDashboardDataMachine.fetchClusters(geo_Region_id, (function (data) {
                return Curry._1(dispatch, {
                            TAG: /* SetClusters */12,
                            clusters: {
                              TAG: /* Live */1,
                              _0: data
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* SetClusters */12,
                            clusters: {
                              TAG: /* Error */2,
                              _0: error
                            }
                          });
              }), country);
}

function getFilterZonalClusterParam(vehicle, geo_region) {
  return {
          geo_region_id: geo_region.id,
          vehicle_id: vehicle.vehicle_id,
          from: 0,
          size: 200
        };
}

function fetchZonalClusterCampaign(vehicle, geo_region, dispatch, country) {
  return AllocationDashboardDataMachine.fetchZoneClusterCampaigns(getFilterZonalClusterParam(vehicle, geo_region), (function (campaigns) {
                return Curry._1(dispatch, {
                            TAG: /* SetZoneClusterCamapigns */13,
                            zoneClusterCampaigns: {
                              TAG: /* Live */1,
                              _0: campaigns
                            }
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* SetZoneClusterCamapigns */13,
                            zoneClusterCampaigns: {
                              TAG: /* Error */2,
                              _0: error
                            }
                          });
              }), country);
}

var intitial_state = {
  user_role: /* Init */0,
  geo_regions: /* Init */0,
  selected_geo_region: undefined,
  vehicles: /* Init */0,
  selected_vehicle: undefined,
  refresh_campaign_list: true,
  applied_filters: {
    campaign_type: /* Mandatory */0,
    start_date: undefined,
    end_date: undefined
  },
  opened_sidebar: undefined,
  snackbar_message: undefined,
  current_view: /* InitialView */0,
  filtered_allocation_campaings: /* Init */0,
  modal: undefined,
  zones: /* Init */0,
  clusters: /* Init */0,
  zoneClusterCampaigns: /* Init */0
};

export {
  intitial_state ,
  reducer ,
  storeSelectedGeoRegionIdInLocalStorage ,
  storeSelectedVehicleIdInLocalStorage ,
  fetchZones ,
  fetchClusters ,
  getFilterZonalClusterParam ,
  fetchZonalClusterCampaign ,
  
}
/* PricingDashboardDataMachine Not a pure module */
